export enum ValidationType { 
        TextFreeFormat = 0,
        NameUpperLowerCase = 1,
        TextUpperLowerCase = 2,
        TextUpperCase = 3,
        TextLowerCase = 4,
        Numeric = 5,
        Currency = 6,
        CurrencyNeg = 7,
        DateTime = 8,
        PostCode = 9,
        Email = 10,
        WebPage = 11,
        FileName = 12,
        ContactLink = 13,
        AccountSortCode = 14,
        AccountNumber = 15,
        TelephoneNumber = 16,
        NumericNeg = 17,
        SMSText = 18,
        IBAN = 19,
        EPC = 20,
        PropertyLink = 21,
        TextFreeFormatNoTrim = 22,
        BriefYourMarketUserName = 23,
        Contact = 24,
        InternationalPassportNumber = 25,
        Percentage = 26,
        PropertyUniqueReferenceNumber = 27,
        Username = 28,
        UserPassword = 29,
        MPRN = 30,
        GPRN = 31,
}
